import { applyMicroSelectUrl } from '@/utils/microSelect'

export default {
  data () {
    return {
      selectUrl: ''
    }
  },
  methods: {
    bindMicroSelectUrl (res) {
      this.selectUrl = applyMicroSelectUrl(res)
    },
    switchMerchant () {
      if (!this.selectUrl) return
      location.href = this.selectUrl
    }
  }
}
